const dataSelectCaretDown = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polygon points="4.5 6.25 8 9.75 11.5 6.25"/></svg>',
};

export { dataSelectCaretDown as default };
